import { create } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';

const initialState = {
  cityName: '',
  latitude: '',
  longitude: '',
  checkIn: '',
  checkOut: '',
  rooms: 1,
  adults: 2,
  children: 0,
  sortingBy: 'Select Custom 1',
  page: 1,
  limit: 20,
  budgetStart: '',
  budgetEnd: '',
  hotelChain: '',
  amenities: '',
  chainList: '',
  pageVip: 0,
  limitVip: 4,
  hotelStar: '',
  hotelName: '',
};

const useSearchStore = create(
  devtools(
    subscribeWithSelector((set) => ({
      ...initialState,
      setParams: (newState) => {
        set((state) => ({ ...state, ...newState }));
      },
      startSearch: (obj) => {
        console.log('search', obj);
        // usePricelineStore().getState().search(obj);
        return set(obj);
      },
      reset: () => {
        set(initialState);
      },
    }))
  )
);
export default useSearchStore;
